  const Flickity = require('flickity');

  module.exports = () => {

    const sliders = document.getElementById('sliders');
    if (sliders) {
      const flkty = new Flickity( sliders, {
        // options
        cellAlign: 'center',
        wrapAround: true,
        autoPlay: 5000,
        cellSelector: '.slider'
      });
    }
  }
